import { FieldArray, useFormikContext } from 'formik'
import React from 'react'
import { SmartChargeSettingsFormModel } from 'src/Libs/smart-charge/models'
import { SingleToggleSettingBox } from 'src/Elements/SystemSettings/forms'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { PowermeterHardwareModel } from 'src/Libs/power-meters/models/power-meter.model'

interface Props {
  name: string
  disabled: boolean
  tooltipText?: string
  powermeterHardwares: PowermeterHardwareModel[]
}

const NO_ID_FALLBACK = '-'
const NO_NAME_FALLBACK = ''

const WeatherForecastActiveFieldList: React.FC<Props> = ({ name, disabled, tooltipText = '', powermeterHardwares }) => {
  const { t } = useCustomTranslation()
  const { values } = useFormikContext<SmartChargeSettingsFormModel>()

  const listRenderer = (): React.ReactNode => {
    return values.weatherForecastActive.map((fieldValue, index) => {
      const producerName = powermeterHardwares.find(pmHardware => pmHardware.id === fieldValue.pmId)?.name?.[1]
      const producerNameString = producerName ? ` ${producerName}` : NO_NAME_FALLBACK
      const powermeterId = fieldValue.pmId ?? NO_ID_FALLBACK

      return (
        <SingleToggleSettingBox
          key={`active-field-${name}-${index}`}
          data-qa={'settings-box-weather-calc-mode'}
          title=""
          description={t('systemSettings.smartFunctions.smartCharge.weatherForecast.form.power-meter', {
            name: producerNameString,
            id: powermeterId,
          })}
          name={`${name}.${index}.isActive`}
          disabled={disabled}
          tooltipText={tooltipText}
        />
      )
    })
  }
  return <FieldArray name={name} render={listRenderer}></FieldArray>
}

export default WeatherForecastActiveFieldList
